import React, { ChangeEvent, useState } from "react";
import Logins from "../Components/Auths/Logins";
import { LoginData } from "../types";
import { useAppDispatch } from "../app/store";
import { useLocation, useNavigate } from "react-router-dom";
import { login } from "../features/authSlice";
import { toast } from "react-toastify";

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, SetLoading] = useState(false);
  const location = useLocation();
  //formdata
  const [formData, setFormData] = useState<LoginData>({
    email: "",
    password: "",
  });

  //handle onchange
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const loginUser = (e: React.FormEvent<HTMLFormElement>) => {
    let data = {
      email: formData.email,
      password: formData.password,
    };
    SetLoading(true);
    e.preventDefault();
    dispatch(login(data))
      .unwrap()
      .then((response: string) => {
        SetLoading(false);
        const redirectTo = location.state?.from?.pathname || "/dashboard";
        navigate(redirectTo);
        toast.success(`Login as ${formData.email}`);
      })
      .catch((error: any) => {
        toast.error(error);
        SetLoading(false);
      });
  };
  return (
    <Logins
      formData={formData}
      onchange={handleChange}
      loginUser={loginUser}
      loading={loading}
    />
  );
};

export default Login;
